import React, { useEffect, createElement } from 'react';
import { useLocation } from 'react-router-dom';
type PixelCommand = 'init' | 'track';
type MetaPixelFunction = {
  (command: PixelCommand, ...args: unknown[]): void;
  callMethod?: (command: PixelCommand, ...args: unknown[]) => void;
  queue?: Array<[PixelCommand, ...unknown[]]>;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
const PIXEL_ID = '1039627232152172';
const PIXEL_SCRIPT_ID = 'meta-pixel-script';
export function MetaPixel() {
  const location = useLocation();
  useEffect(() => {
    if (window.fbq) return;
    const fbq: MetaPixelFunction = (command, ...args) => {
      if (fbq.callMethod) {
        fbq.callMethod(command, ...args);
        return;
      }
      fbq.queue?.push([command, ...args]);
    };
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.id = PIXEL_SCRIPT_ID;
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', PIXEL_ID);
  }, []);
  useEffect(() => {
    window.fbq?.('track', 'PageView');
    // La conversión se dispara después de inicializar el pixel y solo en /gracias.
    if (location.pathname === '/gracias') {
      window.fbq?.('track', 'Lead');
    }
  }, [location.pathname, location.search]);
  return <noscript data-id="element-115">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-116" />
    </noscript>;
}